import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation Users($id: Int, $user: UpdatePasswordInput!) {
  updatePassword(id: $id, user: $user) {
    id
  }
}`;

function updateUserPassword({ id, password }) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id: parseInt(id, 10),
      user: { password },
    },
  }).then((res) => res.data.updatePassword);
}

export default updateUserPassword;
